module.exports = __webpack_public_path__ + "static/img/altiumFootprintManage.29a79738.png";